export default "__VITE_ASSET__ffd77ac5__"